// extracted by mini-css-extract-plugin
export var floatingButton = "floating-button-module--floating-button--rRCP4";
export var bounce = "floating-button-module--bounce--EFE6e";
export var floatingButtonSkip = "floating-button-module--floating-button-skip--1R-3J";
export var bounceM = "floating-button-module--bounce-m--3o7sZ";